import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import configureStore, { history } from './configureStore';
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

const store = configureStore();
Amplify.configure(awsconfig);

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById('root')
);
serviceWorker.unregister();
